/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

import { formatBytes } from '../utils/math.utils';

/**
 * @description Pipe to transform file size in B, KB, MB, or GB with 1 decimal place rounding.
 *
 * @author Rajawant Prajapati
 */
@Pipe({
    name: 'formatBytes',
})
export class FormatBytesPipe implements PipeTransform {
    /**
     * Transforms file size in B, KB, MB, or GB with 1 decimal place rounding.
     */
    public transform(size: number): string {
        return formatBytes(size);
    }
}
